import { toString } from 'lodash';
import { getObjectValue } from 'utilities';
import { HandleDraftCellsParams } from './handleDraftCells.types';

const handleDraftCells = (params: HandleDraftCellsParams): void => {
  const { cell, firmSummaryClassNames } = params;
  const { data } = getObjectValue(cell);
  const { draftValue, isDraft } = getObjectValue(data);

  if (isDraft) {
    Object.assign(cell, {
      className: firmSummaryClassNames.disabledCell,
      expr: '', // Avoid overwriting the draft value or an empty formula
      gridType: 'string',
      value: toString(draftValue),
    });
  }
};

export default handleDraftCells;
